import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Keep client-side navigation consistent with the server-rendered document. */
export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const controller = new AbortController();
    let path = pathname;
    try { path = decodeURIComponent(pathname); } catch { /* Server treats malformed paths as missing. */ }
    fetch(`/api/page-metadata/?path=${encodeURIComponent(path)}`, { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error('Metadata unavailable'); return response.json(); })
      .then(info => {
        document.title = info.title;
        for (const name of ['description', 'robots']) {
          let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
          if (!tag) { tag = document.createElement('meta'); tag.name = name; document.head.appendChild(tag); }
          tag.content = info[name];
        }
        let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (info.status === 404) { canonical?.remove(); return; }
        if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
        canonical.href = info.canonical;
      }).catch(() => { /* Preserve server metadata if offline. */ });
    return () => controller.abort();
  }, [pathname]);
  return null;
}
